/**
 * SIEM Integration
 *
 * Security Information and Event Management integration functionality
 */

import { AuditEvent, AuditLevel } from './types';
import { systemLogger } from '@/lib/logging';

export class SiemIntegration {
  private siemEndpoint?: string;
  private auditLevel: AuditLevel;

  constructor(auditLevel: AuditLevel) {
    this.auditLevel = auditLevel;
    this.initializeSiemIntegration();
  }

  /**
   * Initialize SIEM integration
   */
  private initializeSiemIntegration(): void {
    // In production, this would configure SIEM endpoint
    this.siemEndpoint = import.meta.env['VITE_SIEM_ENDPOINT'];
  }

  /**
   * Send audit event to SIEM system
   */
  async sendToSiem(event: AuditEvent): Promise<void> {
    if (!this.siemEndpoint || event.environment === 'development') {
      return;
    }

    try {
      await fetch(this.siemEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(event)
      });
    } catch (error) {
      systemLogger.warn('Failed to send event to SIEM:', (error as Error).message);
    }
  }

  /**
   * Update SIEM endpoint configuration
   */
  updateEndpoint(endpoint: string): void {
    this.siemEndpoint = endpoint;
  }

  /**
   * Check if SIEM integration is active
   */
  isActive(): boolean {
    return Boolean(this.siemEndpoint && this.auditLevel !== 'INFO');
  }
}